<template>
  <div id="kt_aside_menu_wrapper" class="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid">
    <div id="kt_aside_menu" class="kt-aside-menu "
         data-ktmenu-vertical="1"
         data-ktmenu-scroll="1" data-ktmenu-dropdown-timeout="500">
      <ul class="kt-menu__nav">
        <li class="kt-menu__item" aria-haspopup="true">
          <a href="/" class="kt-menu__link">
            <span class="kt-menu__link-icon">
              <i class="fa fa-home" />
            </span>
            <span class="kt-menu__link-text">Home</span>
          </a>
        </li>

        <li v-if="! isPodcaster()" class="kt-menu__item"
            aria-haspopup="true">
          <a href="/items" class="kt-menu__link ">
            <span class="kt-menu__link-icon">
              <i class="la la-file-audio-o" />
            </span>
            <span class="kt-menu__link-text"> {{ getItemLabel(true) }}s</span>
          </a>
        </li>

        <li class="kt-menu__item" aria-haspopup="true">
          <a :href="isPodcaster() ? '/podcast' : '/feeds'" class="kt-menu__link ">
            <span class="kt-menu__link-icon">
              <i class="fa fa-rss" />
            </span>
            <span class="kt-menu__link-text">{{ getFeedLabel(true) }}s</span>
          </a>
        </li>

        <li v-if="isPodcaster() && can_access_people" class="kt-menu__item" aria-haspopup="true">
          <a href="/people" class="kt-menu__link ">
            <span class="kt-menu__link-icon">
              <i class="fa fa-users" />
            </span>
            <span class="kt-menu__link-text">People</span>
          </a>
        </li>

        <li v-perms="['live_feeds']" class="kt-menu__item" aria-haspopup="true">
          <a href="/live-feeds" class="kt-menu__link ">
            <span class="kt-menu__link-icon">
              <i class="fa fa-broadcast-tower" />
            </span>
            <span class="kt-menu__link-text">Live Feeds</span>
          </a>
        </li>

        <li v-perms="['scheduler']" class="kt-menu__item" aria-haspopup="true">
          <a href="/scheduler" class="kt-menu__link ">
            <span class="kt-menu__link-icon">
              <i class="flaticon-event-calendar-symbol" />
            </span>
            <span class="kt-menu__link-text">Scheduler</span>
          </a>
        </li>

        <li class="kt-menu__item" aria-haspopup="true">
          <a href="/storage" class="kt-menu__link ">
            <span class="kt-menu__link-icon">
              <i class="flaticon2-download" />
            </span>
            <span class="kt-menu__link-text">Storage</span>
          </a>
        </li>

        <li class="kt-menu__item" aria-haspopup="true">
          <a href="/artwork" class="kt-menu__link ">
            <span class="kt-menu__link-icon">
              <i class="fa fa-camera-retro" />
            </span>
            <span class="kt-menu__link-text">Artwork</span>
          </a>
        </li>

        <li v-if="isPodcaster() && website_feed_count > 0" class="kt-menu__item" aria-haspopup="true">
          <a :href="user.customer.podcast_website_url" class="kt-menu__link" target="_blank">
            <span class="kt-menu__link-icon">
              <i class="fa fa-globe" />
            </span>
            <span class="kt-menu__link-text">Website</span>
          </a>
        </li>

        <li class="kt-menu__item" aria-haspopup="true">
          <a href="/preferences" class="kt-menu__link ">
            <span class="kt-menu__link-icon">
              <i class="fa fa-cog" />
            </span>
            <span class="kt-menu__link-text">Preferences</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  //  todo: append --active to kt-menu__item to highlight it -->
  data: () => ({
    customer_plan_features: window.customer_plan_features,
    user: window.user,
    website_feed_count: NaN,
  }),
  computed: {
    can_access_people() {
      return this.permissionsCanAccessFeature('people') && this.permissionsCanDoAction('api.people.list');
    },
  },
  beforeMount() {
    this.fetchFeedsWithWebsitesCount();
  },
  methods: {
    async fetchFeedsWithWebsitesCount() {
      const { count } = (await axios.get(`/api/v1/podcast-websites/website-count/${this.user.customer.slug}`)).data.data;
      this.website_feed_count = count;
    },
    userCanAccessFeature(feature_name) {
      return (
        this.permissionsCanAccessFeature(feature_name) &&
                this.permissionsCanAccessFeature(feature_name)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";

@use "~AssetsSass/_variables" as *;

#kt_aside_menu {
  i {
    color: map.get($ss, 'primary');
  }
}
</style>
